import JSEncrypt from "jsencrypt/bin/jsencrypt.min";

// 密钥对生成 http://web.chacuo.net/netrsakeypair

const publicKey =
  "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA6IfxYhg56gUx6xukW1Ie\n" +
  "0Bb2c4rH0jl30TmEMEeV2QTpL4dp+id/l3kKeREcDWw+iSv6IM7grbMHWLic/ATq\n" +
  "w3WB6OWZlG3ykZtacmX7trn+ryLWQCdEvBkn+ogew5AqSvwSCJawIbUsoqpGQb7q\n" +
  "6tUAvnQ23w3LIDA6R4atR5mVrsujoVf8364/tzy32oAPh46kl1BdGKDn3yIgCDz2\n" +
  "FNUlFDnB4shlkxXv1jx7RFNkAQGRbzfllVz3/q/TcnLZ7hs0LP/ixj6NKY7XHXLr\n" +
  "o8Bc2OAUhrxsysaVx1o1wlfUauc/4BgfWhQt/DGXEQiPlkYwlJ6ecHz+hH8pH/YR\n" +
  "ywIDAQAB";

const privateKey =
  "MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQDoh/FiGDnqBTHr\n" +
  "G6RbUh7QFvZzisfSOXfROYQwR5XZBOkvh2n6J3+XeQp5ERwNbD6JK/ogzuCtswdY\n" +
  "uJz8BOrDdYHo5ZmUbfKRm1pyZfu2uf6vItZAJ0S8GSf6iB7DkCpK/BIIlrAhtSyi\n" +
  "qkZBvurq1QC+dDbfDcsgMDpHhq1HmZWuy6OhV/zfrj+3PLfagA+HjqSXUF0YoOff\n" +
  "IiAIPPYU1SUUOcHiyGWTFe/WPHtEU2QBAZFvN+WVXPf+r9NyctnuGzQs/+LGPo0p\n" +
  "jtcdcuujwFzY4BSGvGzKxpXHWjXCV9Rq5z/gGB9aFC38MZcRCI+WRjCUnp5wfP6E\n" +
  "fykf9hHLAgMBAAECggEBAKNTWOhdu8/z9iv9LmQ2Og5PEqv1PoUaeF4s1/xRS58z\n" +
  "I9aOdpGOTMBH9GM08U88SHBwwy9oH8fhh7d5dEpP6dWAI89B9a2bzFUZmV3g4/xk\n" +
  "h87b2UEWU+EKiloeYf1atVoV01TVAsGqT7+xeceUIczv76XWWvQw7Auf1E+I+Qzg\n" +
  "LMtpXDN/jyCetWzI/Pw/xuhHNjcATraaqQ5XnpZZZGTSXtTBpAABlWJFRivgMcXC\n" +
  "o9GFP73OlAMHIopZPu/60xEhc9Jpt8Qun60CLSU8c8HI0ap4Or1RmNoT+WUdeob9\n" +
  "odDp25THhbtQ1xCKkPYq9vOqM6AlT6QVudy2w/iUKwECgYEA93D7Gsi1HT9T+ToX\n" +
  "0F1I8ZUbFNWXY5FiN2Lkhp2RqtEfF1HNQBuat6IQLqifYukxSnxkEfQsIXFZK7vf\n" +
  "Y+Y7IsppTZ6vzbzzJN9zMe5Q5mgLWnZfsUsMSJgszV9+HEQWjE6gboyFEYAQPtt9\n" +
  "oZNv5WC6gzVf4I9xcWRUpAkuQrkCgYEA8JLvi/piQiDD3OSMsQDWSZeclybyg5ba\n" +
  "f37RPJ7EmBDGrEj2HN0gNpiD+PaWb0IED0MTCR4/XYk2wNz0J5lr7j3Uk2z1WnQg\n" +
  "OtgcvtvK8ko66Et9Poq5XHVD/Ds95G9wTdA4sGkuAGZNgjTkiNcLpSUT3hOPoI1I\n" +
  "mqMku3XbRqMCgYBrUkSHLHBpnBMG8OxtQlil938EfVOpKuCHl0v5GxSYGxW6Ho/A\n" +
  "c3ialx8fraFb3Dq1zNf2dYpCgxAjCNxuTuhtQY+EzAQCXyayYnxrNqs+E/iApwEA\n" +
  "O8W7Is2j0fw3tEx3VI7/A9GfcoUZTkfiMbmBqn+a8yZ/lpekj9iqQRUgeQKBgCt2\n" +
  "YFCpq5bG1JvTrpdLz2r8OQ4VuzqKxm7COor5JAtU/I+jntMYH/m9FBqmcgcnphQb\n" +
  "yhSbolcDsyCkynddAGLKSN1ZkfoFgM0gvhC9JK0hPAM7oCTsaxCJHv8ytLvQZjmo\n" +
  "pJU6a1UnJlmftKoEL9ZmHHDCl/ApljRZxQkZAcSBAoGACVq/3baGFvXRfoL0pSF8\n" +
  "ll8HWNcp+fZiNvcvivab8U0+lC1P0alM0b0GLy5cEL60WJFA6M3vNedl0aHF5aFi\n" +
  "IAspZ/cfgh2ctxtY40wIBzWt8b/r/SGa2JuZnz9hvzFBIJPEMVHzWGmNq959D3Tf\n" +
  "uvdfR/EfCC0XQAVREzNo9y0=";

// 加密
export function encrypt(txt) {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey); // 设置公钥
  return encryptor.encrypt(txt); // 对数据进行加密
}

// 解密
export function decrypt(txt) {
  const encryptor = new JSEncrypt();
  encryptor.setPrivateKey(privateKey); // 设置私钥
  return encryptor.decrypt(txt); // 对数据进行解密
}
